//NPM
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Actions, Services, Selectors
import { currentUserSelector } from 'selectors/userSelectors';

// Components
import WrapInModal from 'Components/ModalWrapper';
import LoginForm, { LOGIN_KEY } from './LoginForm';
import RegistrationForm, { REGISTRATION_KEY } from './RegistrationForm';
import PasswordResetForm, { RESET_KEY } from './PasswordResetForm';
import PasswordUpdateForm, { PASSWORD_UPDATE_KEY } from './PasswordUpdateForm';

export const MODAL_NAME = 'Auth';

export const FORM_KEYS = {
  login: LOGIN_KEY,
  registration: REGISTRATION_KEY,
  reset: RESET_KEY,
  passwordUpdate: PASSWORD_UPDATE_KEY,
};

const FORM_MAP = {
  [FORM_KEYS.login]: LoginForm,
  [FORM_KEYS.registration]: RegistrationForm,
  [FORM_KEYS.reset]: PasswordResetForm,
  [FORM_KEYS.passwordUpdate]: PasswordUpdateForm,
};

class AuthModalBody extends PureComponent {
  componentDidUpdate = prevProps => {
    if (prevProps.user !== this.props.user) {
      this.props.closeModal();
    }
  };

  render() {
    const { formToDisplay, ...otherProps } = this.props;
    const Component = FORM_MAP[formToDisplay];
    return <Component {...otherProps} />;
  }
}

AuthModalBody.propTypes = {
  formToDisplay: PropTypes.oneOf(Object.keys(FORM_MAP)).isRequired,
  closeModal: PropTypes.func.isRequired,
  updateModal: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: currentUserSelector(state),
  };
}

export default WrapInModal(connect(mapStateToProps)(AuthModalBody), MODAL_NAME);



// WEBPACK FOOTER //
// ./src/Components/Auth/AuthModal/index.js